import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center bg-success border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-light h3" }, "Pending Course")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end col",
    "data-kt-industry-table-toolbar": "base"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_CourseInfoDrawer = _resolveComponent("CourseInfoDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(), _createElementBlock("div", {
        key: _ctx.componentKey,
        class: "card-body pt-4"
      }, [
        _hoisted_3,
        _createVNode(_component_Datatable, {
          "table-data": _ctx.courseList,
          "table-header": _ctx.courseHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-code": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.code), 1)
          ]),
          "cell-course_name": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.course_name), 1)
          ]),
          "cell-term": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.term), 1)
          ]),
          "cell-session": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.session), 1)
          ]),
          "cell-tranche": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.tranche_single_info?.label), 1)
          ]),
          "cell-course_type": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.course_type_info?.type_name), 1)
          ]),
          "cell-isManagementCourse": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.isManagementCourse == 1 ? 'Yes' : 'No'), 1)
          ]),
          "cell-isStipendCourse": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.isStipendCourse == 1 ? 'Yes' : 'No'), 1)
          ]),
          "cell-isTotCourse": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.isTotCourse == 1 ? 'Yes' : 'No'), 1)
          ]),
          "cell-isEmploymentEligible": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.isEmploymentEligible == 1 ? 'Yes' : 'No'), 1)
          ]),
          "cell-month": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.month), 1)
          ]),
          "cell-hour": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.hour), 1)
          ]),
          "cell-ttd": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.day), 1)
          ]),
          "cell-total_target_trainee": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.total_target_trainee), 1)
          ]),
          "cell-unit_cost": _withCtx(({ row: course }) => [
            _createTextVNode(_toDisplayString(course?.unit_cost_total), 1)
          ]),
          "cell-actions": _withCtx(({ row: course }) => [
            _createVNode(_component_router_link, {
              class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
              to: {
              name: 'courseProfileDetails',
              params: { id: course.id },
            }
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("button", {
              "data-kt-drawer-toggle": "true",
              "data-kt-drawer-target": "#kt_drawer_course_info",
              onClick: ($event: any) => (_ctx.edit(course)),
              id: "kt_drawer_course_info_button",
              class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
            }, _hoisted_7, 8, _hoisted_5),
            (_ctx.actionApprove)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.Approve(course.id)),
                  class: "btn btn-icon btn-bg-success btn-active-color-primary btn-sm me-1"
                }, _hoisted_10, 8, _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.actionReject)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.Reject(course.id)),
                  class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                }, _hoisted_13, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          "cell-requested_by": _withCtx(({ row: industry }) => [
            _createTextVNode(_toDisplayString(industry?.request_by), 1)
          ]),
          "cell-requested_date_time": _withCtx(({ row: industry }) => [
            _createTextVNode(_toDisplayString(industry?.request_date_time), 1)
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ]))
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _createVNode(_component_CourseInfoDrawer)
  ], 64))
}